(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["gs-virtual-drape"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('gs-virtual-drape')) {
    customElements.define(
      'gs-virtual-drape',
      class extends HTMLElement {
        connectedCallback() {
          if (this.initialized) return;
          this.initialized = true;
          this.openButton = this.querySelector('[data-drape-open]');
          this.dialog = this.querySelector('[data-drape-dialog]');
          this.form = this.querySelector('[data-drape-form]');
          this.fileInput = this.querySelector('[data-drape-photo]');
          this.consent = this.querySelector('[data-drape-consent]');
          this.submitButton = this.querySelector('[data-drape-submit]');
          this.submitLabel = this.querySelector('[data-submit-label]');
          this.error = this.querySelector('[data-drape-error]');
          this.previewWrap = this.querySelector('[data-photo-preview-wrap]');
          this.previewImage = this.querySelector('[data-photo-preview]');
          this.removeButton = this.querySelector('[data-photo-remove]');
          this.progress = this.querySelector('[data-drape-progress]');
          this.progressTitle = this.querySelector('[data-progress-title]');
          this.result = this.querySelector('[data-drape-result]');
          this.resultImage = this.querySelector('[data-result-image]');
          this.resultLink = this.querySelector('[data-result-link]');
          this.againButton = this.querySelector('[data-drape-again]');
          this.sources = this.querySelector('[data-drape-form]').parentElement;
          this.photoBlob = null;
          this.photoUrl = '';
          this.controller = null;

          this.openButton.addEventListener('click', () => this.open());
          this.dialog.addEventListener('click', (event) => {
            if (event.target === this.dialog) this.dialog.close();
          });
          this.dialog.addEventListener('close', () => {
            if (this.controller) this.controller.abort();
            this.controller = null;
            if (!this.progress.hidden) {
              this.progress.hidden = true;
              this.sources.hidden = false;
              this.submitButton.disabled = false;
            }
            this.openButton.focus();
          });
          this.fileInput.addEventListener('change', () => this.preparePhoto());
          this.removeButton.addEventListener('click', () => this.clearPhoto());
          this.form.addEventListener('submit', (event) => this.generate(event));
          this.againButton.addEventListener('click', () => this.reset());
        }

        open() {
          this.hideError();
          if (typeof this.dialog.showModal === 'function') {
            this.dialog.showModal();
          } else {
            this.dialog.setAttribute('open', '');
          }
          requestAnimationFrame(() => this.fileInput.focus());
        }

        async preparePhoto() {
          this.hideError();
          const file = this.fileInput.files && this.fileInput.files[0];
          if (!file) {
            this.clearPhoto();
            return;
          }

          const allowedTypes = ['image/jpeg', 'image/png', 'image/webp'];
          if (!allowedTypes.includes(file.type)) {
            this.showError(this.dataset.errorFile);
            this.clearPhoto();
            return;
          }

          const maxBytes = Number(this.dataset.maxBytes || 10485760);
          if (file.size > maxBytes) {
            this.showError(this.dataset.errorSize);
            this.clearPhoto();
            return;
          }

          this.submitButton.disabled = true;

          try {
            const image = await this.decodeImage(file);
            const width = image.width || image.naturalWidth;
            const height = image.height || image.naturalHeight;
            if (width < 600 || height < 800) {
              if (image.close) image.close();
              throw new Error('dimensions');
            }

            const longestEdge = Math.max(width, height);
            const scale = Math.min(1, 2048 / longestEdge);
            const outputWidth = Math.round(width * scale);
            const outputHeight = Math.round(height * scale);
            const canvas = document.createElement('canvas');
            canvas.width = outputWidth;
            canvas.height = outputHeight;
            const context = canvas.getContext('2d', { alpha: false });
            context.fillStyle = '#ffffff';
            context.fillRect(0, 0, outputWidth, outputHeight);
            context.drawImage(image, 0, 0, outputWidth, outputHeight);
            if (image.close) image.close();

            this.photoBlob = await new Promise((resolve, reject) => {
              canvas.toBlob(
                (blob) => {
                  if (blob) resolve(blob);
                  else reject(new Error('encode'));
                },
                'image/jpeg',
                0.88
              );
            });

            if (this.photoUrl) URL.revokeObjectURL(this.photoUrl);
            this.photoUrl = URL.createObjectURL(this.photoBlob);
            this.previewImage.src = this.photoUrl;
            this.previewWrap.hidden = false;
            this.querySelector('.gs-drape__upload').hidden = true;
          } catch (error) {
            this.clearPhoto();
            if (error.message === 'dimensions') {
              this.showError(this.dataset.errorDimensions);
            } else {
              this.showError(this.dataset.errorFile);
            }
          } finally {
            this.submitButton.disabled = false;
          }
        }

        async decodeImage(file) {
          if ('createImageBitmap' in window) {
            try {
              return await createImageBitmap(file, { imageOrientation: 'from-image' });
            } catch (error) {
              try {
                return await createImageBitmap(file);
              } catch (fallbackError) {
                return this.decodeImageElement(file);
              }
            }
          }

          return this.decodeImageElement(file);
        }

        decodeImageElement(file) {
          return new Promise((resolve, reject) => {
            const image = new Image();
            const url = URL.createObjectURL(file);
            image.onload = () => {
              URL.revokeObjectURL(url);
              resolve(image);
            };
            image.onerror = () => {
              URL.revokeObjectURL(url);
              reject(new Error('decode'));
            };
            image.src = url;
          });
        }

        clearPhoto() {
          this.fileInput.value = '';
          this.photoBlob = null;
          this.previewImage.removeAttribute('src');
          this.previewWrap.hidden = true;
          this.querySelector('.gs-drape__upload').hidden = false;
          if (this.photoUrl) {
            URL.revokeObjectURL(this.photoUrl);
            this.photoUrl = '';
          }
        }

        async generate(event) {
          event.preventDefault();
          this.hideError();

          if (!this.photoBlob) {
            this.showError(this.dataset.errorFile);
            this.fileInput.focus();
            return;
          }

          if (!this.consent.checked) {
            this.showError(this.dataset.errorConsent);
            this.consent.focus();
            return;
          }

          let endpoint;
          try {
            endpoint = this.safeUrl(this.dataset.endpoint);
          } catch (error) {
            this.showError(this.dataset.errorEndpoint);
            return;
          }

          this.controller = new AbortController();
          this.setBusy(true);
          this.progressTitle.textContent = this.dataset.uploading;

          const payload = new FormData();
          payload.append('photo', this.photoBlob, 'virtual-saree-drape-photo.jpg');
          payload.append('saree_image_url', this.dataset.sareeImage);
          payload.append('saree_title', this.dataset.sareeTitle);
          payload.append('product_id', this.dataset.productId);
          payload.append('product_handle', this.dataset.productHandle);
          payload.append('variant_id', this.currentVariantId());
          payload.append('drape_style', 'classic_nivi');
          payload.append('locale', this.dataset.locale);
          payload.append('consent', 'true');

          try {
            const response = await fetch(endpoint.href, {
              method: 'POST',
              headers: { Accept: 'application/json' },
              body: payload,
              credentials: endpoint.origin === window.location.origin ? 'same-origin' : 'omit',
              signal: this.controller.signal
            });
            const data = await this.readJson(response);

            if (!response.ok) {
              throw new Error(data.message || this.dataset.errorResponse);
            }

            this.progressTitle.textContent = this.dataset.processing;
            const imageUrl = this.extractImageUrl(data);
            if (imageUrl) {
              this.showResult(imageUrl);
              return;
            }

            if (data.status_url) {
              await this.poll(data.status_url);
              return;
            }

            throw new Error(this.dataset.errorResponse);
          } catch (error) {
            if (error.name === 'AbortError') return;
            this.setBusy(false);
            this.showError(error.message || this.dataset.errorGeneric);
          }
        }

        async poll(statusUrl) {
          const url = this.safeUrl(statusUrl);

          for (let attempt = 0; attempt < 45; attempt += 1) {
            await new Promise((resolve) => window.setTimeout(resolve, 2000));
            const response = await fetch(url.href, {
              method: 'GET',
              headers: { Accept: 'application/json' },
              credentials: url.origin === window.location.origin ? 'same-origin' : 'omit',
              signal: this.controller.signal
            });
            const data = await this.readJson(response);

            if (!response.ok || data.status === 'failed' || data.status === 'error') {
              throw new Error(data.message || this.dataset.errorResponse);
            }

            const imageUrl = this.extractImageUrl(data);
            if (imageUrl) {
              this.showResult(imageUrl);
              return;
            }
          }

          throw new Error(this.dataset.errorTimeout);
        }

        async readJson(response) {
          const contentType = response.headers.get('content-type') || '';
          if (!contentType.includes('application/json')) {
            throw new Error(this.dataset.errorEndpoint);
          }
          return response.json();
        }

        extractImageUrl(data) {
          const value =
            data.image_url ||
            data.result_url ||
            data.output_url ||
            (data.result && data.result.image_url) ||
            (Array.isArray(data.output) && data.output[0]);
          if (!value) return '';
          return this.safeResultUrl(value);
        }

        safeUrl(value) {
          if (!value) throw new Error('missing endpoint');
          const url = new URL(value, window.location.origin);
          if (url.protocol !== 'https:' && url.origin !== window.location.origin) {
            throw new Error('unsafe endpoint');
          }
          return url;
        }

        safeResultUrl(value) {
          const url = new URL(value, window.location.origin);
          if (url.protocol !== 'https:' && url.origin !== window.location.origin) {
            throw new Error(this.dataset.errorResponse);
          }
          return url.href;
        }

        currentVariantId() {
          const selector = document.getElementById('Variant-' + this.dataset.sectionId);
          return selector ? selector.value : this.dataset.variantId;
        }

        showResult(imageUrl) {
          const render = () => {
            this.resultImage.src = imageUrl;
            this.resultLink.href = imageUrl;
            this.sources.hidden = true;
            this.progress.hidden = true;
            this.result.hidden = false;
            this.submitButton.disabled = false;
            this.submitLabel.textContent = this.dataset.complete;
          };

          if (document.startViewTransition) {
            document.startViewTransition(render);
          } else {
            render();
          }
        }

        reset() {
          if (this.controller) this.controller.abort();
          this.controller = null;
          this.resultImage.removeAttribute('src');
          this.resultLink.href = '#';
          this.result.hidden = true;
          this.progress.hidden = true;
          this.sources.hidden = false;
          this.consent.checked = false;
          this.clearPhoto();
          this.hideError();
          this.submitLabel.textContent = this.dataset.complete;
          this.fileInput.focus();
        }

        setBusy(isBusy) {
          this.sources.hidden = isBusy;
          this.progress.hidden = !isBusy;
          this.result.hidden = true;
          this.submitButton.disabled = isBusy;
        }

        showError(message) {
          this.error.textContent = message || this.dataset.errorGeneric;
          this.error.hidden = false;
          this.sources.hidden = false;
          this.progress.hidden = true;
          this.result.hidden = true;
        }

        hideError() {
          this.error.textContent = '';
          this.error.hidden = true;
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
